module.exports = __webpack_public_path__ + "media/images/2-01-64e6fb634221e69689055c02ad269f45.svg";